var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('headers',{ref:"headers",attrs:{"title":_vm.title}}),_c('div',{staticStyle:{"width":"10rem","height":"21.6533rem"}},[_c('iframe',{attrs:{"src":_vm.url,"frameborder":"0","width":"100%","height":"100%"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }